import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
    customerId: string;
    onError?: (err: Error) => void
}

export const useInvoiceRecipientsQuery = ({ customerId, onError }:IProps) => useQuery(
  'useInvoiceRecipientsQuery',
  async () => {
    const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/recipients?recordCnt=100`);
    return res?.data?.recipients || [];
  },
  {
    enabled: true,
    refetchOnWindowFocus: false,
    onError: (err: Error) => {
      if (onError) {
        onError(err);
      }
    },
  },
);
